export const RadixIcon = () => (
  <svg width="22" height="22" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19.5010505,19.0323946 C19.3403919,16.5578896 20.1560444,13.0799214 21.8618254,10.3568809 C24.1748936,6.66439148 27.8748111,4.5 33,4.5 L33.5,4.5 L33.5,5 C33.5,15.0701025 28.0593151,19.9048912 19.974951,19.4993722 L19.52992,19.477049 L19.5010505,19.0323946 Z" />
      <path d="M27,11 C23.6666667,13.6666667 21.3333333,16.3333333 20,19 C17.3333333,23 19.6666667,31 27,43" />
      <path d="M22,33 C27.6666667,37 33.3333333,38.4166667 39,37.25" />
      <path d="M24,38 C20,41.3333333 16,42.3333333 12,41" />
      <path d="M20,29 C19,33 16,37 8,38" />
    </g>
  </svg>
);
